import api from '@/api/index.js'

const operator_assignees = {
  state: {
    loading: false,
    updating: false,
    data: [],
    error: null
  },

  mutations: {
    SET_OPERATOR_ASSIGNEES_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_OPERATOR_ASSIGNEES_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_OPERATOR_ASSIGNEES: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    ADD_OPERATOR_ASSIGNEE: (state, assignee) => {
      state.data.push(assignee)
      state.updating = false;
    },
    REMOVE_OPERATOR_ASSIGNEE: (state, assigneeID) => {
      state.data = state.data.filter(e => e.id !== assigneeID)
      state.updating = false;
    },
    SET_OPERATOR_ASSIGNEES_ERROR: (state, error) => {
      state.error = error;
      state.updating = false;
      state.loading = false;
    }
  },

  actions: {
    LoadOperatorAssignees({commit}, id) {
      commit('SET_OPERATOR_ASSIGNEES_ERROR', null)
      commit('SET_OPERATOR_ASSIGNEES_LOADING', true)
      return api.get(`operators/${id}/assignees`)
        .then((response) => {
          commit('SET_OPERATOR_ASSIGNEES', response)
        })
        .catch((error) => {
          commit('SET_OPERATOR_ASSIGNEES_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
    CreateOperatorAssignee({commit}, payload) {
      commit('SET_OPERATOR_ASSIGNEES_UPDATING', true);
      commit('SET_OPERATOR_ASSIGNEES_ERROR', null)
      return api.post(`system-accounts/${payload.systemAccountId}/assigned-operators`, payload.data)
        .then((response) => {
          commit('ADD_OPERATOR_ASSIGNEE', response.body);
        })
        .catch((error) => {
          commit('SET_OPERATOR_ASSIGNEES_ERROR', error);
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
    DeleteOperatorAssignee({commit}, payload) {
      commit('SET_OPERATOR_ASSIGNEES_UPDATING', true);
      commit('SET_OPERATOR_ASSIGNEES_ERROR', null)
      return api.delete(`system-accounts/${payload.systemAccountId}/assigned-operators/${payload.operatorId}`)
        .then((response) => {
          commit('REMOVE_OPERATOR_ASSIGNEE', payload.systemAccountId);
        })
        .catch((error) => {
          commit('SET_OPERATOR_ASSIGNEES_ERROR', error);
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
  },
}

export default operator_assignees

